import * as i0 from '@angular/core';
import { Input, Directive, ViewChild, Attribute, Component, NgModule } from '@angular/core';
import * as i1 from '@azavista/components/shared';
import { AzavistaElementAttributesDirective, AzavistaSharedModule } from '@azavista/components/shared';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2$1 from '@angular/common';
import * as i4 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
const _c0 = ["btn"];
const _c1 = ["*"];
function AzavistaMiniFabButtonComponent_mat_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.icon);
  }
}
function AzavistaIconButtonComponent_mat_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.icon);
  }
}
let AzavistaButtonAttributesDirective = /*#__PURE__*/(() => {
  class AzavistaButtonAttributesDirective extends AzavistaElementAttributesDirective {
    set attributes(value) {
      super.attributes = value;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵAzavistaButtonAttributesDirective_BaseFactory;
        return function AzavistaButtonAttributesDirective_Factory(__ngFactoryType__) {
          return (ɵAzavistaButtonAttributesDirective_BaseFactory || (ɵAzavistaButtonAttributesDirective_BaseFactory = i0.ɵɵgetInheritedFactory(AzavistaButtonAttributesDirective)))(__ngFactoryType__ || AzavistaButtonAttributesDirective);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: AzavistaButtonAttributesDirective,
        selectors: [["button", "azavistaButtonAttributes", ""]],
        inputs: {
          attributes: [0, "azavistaButtonAttributes", "attributes"]
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return AzavistaButtonAttributesDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaButtonComponent = /*#__PURE__*/(() => {
  class AzavistaButtonComponent {
    constructor(color, sharedSvc) {
      this.color = color;
      this.sharedSvc = sharedSvc;
      this.disabled = false;
      this.cssClasses = [];
      this.containerCssClasses = [];
      this.hasAccess = true;
    }
    ngOnInit() {
      this.btn.color = this.color;
    }
    ngOnChanges(simpleChanges) {
      if (simpleChanges.acl) {
        this.hasAccess = this.sharedSvc.hasAccess(this.acl);
        this.btn.disabled = !this.hasAccess || this.disabled;
      }
      if (simpleChanges.disabled) {
        this.btn.disabled = simpleChanges.disabled.currentValue;
      }
    }
    onClicked(event) {
      if (this.btn.disabled) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
    static {
      this.ɵfac = function AzavistaButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaButtonComponent)(i0.ɵɵinjectAttribute('color'), i0.ɵɵdirectiveInject(i1.AzavistaSharedService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaButtonComponent,
        selectors: [["azavista-button"]],
        viewQuery: function AzavistaButtonComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.btn = _t.first);
          }
        },
        inputs: {
          acl: "acl",
          disabled: "disabled",
          cssClasses: "cssClasses",
          containerCssClasses: "containerCssClasses",
          buttonAttributes: "buttonAttributes"
        },
        standalone: false,
        features: [i0.ɵɵNgOnChangesFeature],
        ngContentSelectors: _c1,
        decls: 4,
        vars: 5,
        consts: [["btn", ""], [1, "azavista-button-component", "button-container", 3, "click"], ["mat-raised-button", "", 3, "azavistaButtonAttributes"]],
        template: function AzavistaButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("click", function AzavistaButtonComponent_Template_div_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClicked($event));
            });
            i0.ɵɵelementStart(1, "button", 2, 0);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.containerCssClasses);
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.cssClasses);
            i0.ɵɵproperty("azavistaButtonAttributes", ctx.buttonAttributes);
          }
        },
        dependencies: [i2.MatButton, AzavistaButtonAttributesDirective],
        encapsulation: 2
      });
    }
  }
  return AzavistaButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaFlatButtonComponent = /*#__PURE__*/(() => {
  class AzavistaFlatButtonComponent extends AzavistaButtonComponent {
    constructor(color, sharedSvc) {
      super(color, sharedSvc);
      this.color = color;
      this.sharedSvc = sharedSvc;
    }
    static {
      this.ɵfac = function AzavistaFlatButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaFlatButtonComponent)(i0.ɵɵinjectAttribute('color'), i0.ɵɵdirectiveInject(i1.AzavistaSharedService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaFlatButtonComponent,
        selectors: [["azavista-flat-button"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c1,
        decls: 4,
        vars: 3,
        consts: [["btn", ""], [1, "azavista-flat-button-component", "button-container", 3, "click"], ["mat-button", "", 3, "azavistaButtonAttributes"]],
        template: function AzavistaFlatButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("click", function AzavistaFlatButtonComponent_Template_div_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClicked($event));
            });
            i0.ɵɵelementStart(1, "button", 2, 0);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.cssClasses);
            i0.ɵɵproperty("azavistaButtonAttributes", ctx.buttonAttributes);
          }
        },
        dependencies: [i2.MatButton, AzavistaButtonAttributesDirective],
        encapsulation: 2
      });
    }
  }
  return AzavistaFlatButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaMiniFabButtonComponent = /*#__PURE__*/(() => {
  class AzavistaMiniFabButtonComponent extends AzavistaButtonComponent {
    constructor(color, sharedSvc) {
      super(color, sharedSvc);
      this.color = color;
      this.sharedSvc = sharedSvc;
    }
    static {
      this.ɵfac = function AzavistaMiniFabButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaMiniFabButtonComponent)(i0.ɵɵinjectAttribute('color'), i0.ɵɵdirectiveInject(i1.AzavistaSharedService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaMiniFabButtonComponent,
        selectors: [["azavista-mini-fab-button"]],
        inputs: {
          icon: "icon"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 4,
        consts: [["btn", ""], [1, "azavista-mini-fab-component", "button-container", 3, "click"], ["mat-mini-fab", "", 3, "azavistaButtonAttributes"], [4, "ngIf"]],
        template: function AzavistaMiniFabButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("click", function AzavistaMiniFabButtonComponent_Template_div_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClicked($event));
            });
            i0.ɵɵelementStart(1, "button", 2, 0);
            i0.ɵɵtemplate(3, AzavistaMiniFabButtonComponent_mat_icon_3_Template, 2, 1, "mat-icon", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.cssClasses);
            i0.ɵɵproperty("azavistaButtonAttributes", ctx.buttonAttributes);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.icon);
          }
        },
        dependencies: [i2$1.NgIf, i2.MatMiniFabButton, i4.MatIcon, AzavistaButtonAttributesDirective],
        encapsulation: 2
      });
    }
  }
  return AzavistaMiniFabButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaIconButtonComponent = /*#__PURE__*/(() => {
  class AzavistaIconButtonComponent extends AzavistaButtonComponent {
    constructor(color, sharedSvc) {
      super(color, sharedSvc);
      this.color = color;
      this.sharedSvc = sharedSvc;
    }
    static {
      this.ɵfac = function AzavistaIconButtonComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaIconButtonComponent)(i0.ɵɵinjectAttribute('color'), i0.ɵɵdirectiveInject(i1.AzavistaSharedService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaIconButtonComponent,
        selectors: [["azavista-icon-button"]],
        inputs: {
          icon: "icon"
        },
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 4,
        consts: [["btn", ""], [1, "azavista-icon-button-component", "button-container", 3, "click"], ["mat-icon-button", "", 3, "azavistaButtonAttributes"], [4, "ngIf"]],
        template: function AzavistaIconButtonComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("click", function AzavistaIconButtonComponent_Template_div_click_0_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onClicked($event));
            });
            i0.ɵɵelementStart(1, "button", 2, 0);
            i0.ɵɵtemplate(3, AzavistaIconButtonComponent_mat_icon_3_Template, 2, 1, "mat-icon", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵclassMap(ctx.cssClasses);
            i0.ɵɵproperty("azavistaButtonAttributes", ctx.buttonAttributes);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.icon);
          }
        },
        dependencies: [i2$1.NgIf, i2.MatIconButton, i4.MatIcon, AzavistaButtonAttributesDirective],
        encapsulation: 2
      });
    }
  }
  return AzavistaIconButtonComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaButtonModule = /*#__PURE__*/(() => {
  class AzavistaButtonModule {
    static {
      this.ɵfac = function AzavistaButtonModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaButtonModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaButtonModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [AzavistaSharedModule, MatButtonModule, MatIconModule]
      });
    }
  }
  return AzavistaButtonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaButtonComponent, AzavistaButtonModule, AzavistaFlatButtonComponent, AzavistaIconButtonComponent, AzavistaMiniFabButtonComponent };
